import { Component, OnInit } from "@angular/core";
import { Router, NavigationExtras } from "@angular/router";
import { AuthService } from "../auth/auth.service";
import { LoginService } from "./login.service";
import { LocalStorageService } from "ng2-webstorage";
import { TranslateService } from "../../../language/translate.service";
import { TemplateType } from 'src/app/shared/utils/template-type';

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
	UserName: string = "";
	Pass: string = "";
	capCha: string;
	capChaRequired: string;
	footerInfo: any;
	whatBank: any = {};

	constructor(
		public authService: AuthService,
		public loginService: LoginService,
		public router: Router,
		private translate: TranslateService,
		private localStorageService: LocalStorageService,
		private templateType: TemplateType,
	) { }

	ngOnInit() {
		this.bank();
		this.UserName = "";
		this.Pass = "";
		//get footer infomation
		this.loginService.getFooterInfo().subscribe(result => {
			this.footerInfo = result;
		});
		setTimeout(() => {
			this.changeCapCha();
		}, 0);
	}

	changeCapCha() {
		const str = Math.random().toString(36);
		this.capChaRequired = str.substring(str.length - 5, str.length);
		const canvas = <HTMLCanvasElement>document.getElementById("capChaRequired");
		const ctx = canvas.getContext("2d");
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.font = '400 30px "Segoe UI"';
		ctx.fillStyle = "#fff";
		ctx.fillText(this.capChaRequired, 1, canvas.height / 2 + 8);
		if (this.capChaRequired.length > 5) {
			this.changeCapCha();
		}
	}

	login() {
		if (this.capCha != this.capChaRequired) {
			this.capCha = "";
			this.changeCapCha();
			setTimeout(() => {
				let messageKey = "message.capChaNotMatch";
				this.router.navigate(
					[
						{
							outlets: {
								notification: "notification/" + messageKey
							}
						}
					],
					{
						replaceUrl: true
					}
				);
			});
		} else {
			this.capCha = "";
			this.changeCapCha();
			if (this.checkLogin()) {
				this.authService.PTlogin(this.UserName, this.Pass).subscribe(x => {
					let item: any;
					item = x;
					if (item.data != null) {
						// truong hop chua doi password
						if (item.data.passwordStatus == 2) {
							let info = JSON.stringify(item.data);
							sessionStorage.setItem("login", info);
							sessionStorage.setItem("UserId", item.data.id);
							let navigationExtras: NavigationExtras = {
								queryParamsHandling: "preserve",
								preserveFragment: true
							};
							let messageKey = 'message.notChangePasswordError';
							this.router.navigate(
								[
									{
										outlets: {
											notification: "notification/" + messageKey
										}
									}
								],
								{
									replaceUrl: true
								}
							);
							setTimeout(() => {
								this.router.navigate(["/change-password"], navigationExtras);
							}, 0);
						} else {
							// Get the redirect URL from our auth service
							// If no redirect has been set, use the default
							let redirect = this.authService.redirectUrl
								? this.authService.redirectUrl
								: "/invoice-list";
							// Set our navigation extras object
							// that passes on our global query params and fragment
							let navigationExtras: NavigationExtras = {
								queryParamsHandling: "preserve",
								preserveFragment: true
							};

							let info = JSON.stringify(item.data);
							sessionStorage.setItem("login", info);

							// Redirect the user
							this.router.navigate([redirect], navigationExtras);
						}
					} else {
						let messageKey = '';
						if (item.code == 2001) {
							messageKey = 'error.code.' + item.code;
						} else {
							messageKey = 'error.code.' + item.code;
						}
						this.router.navigate(
							[
								{
									outlets: {
										notification: "notification/" + messageKey
									}
								}
							],
							{
								replaceUrl: true
							}
						);
					}
				});
			}
		}
	}

	checkLogin() {
		let isErr = false;
		let messageKey = "";
		if (this.UserName == "") {
			isErr = true;
			messageKey = "message.userNameIsEmptyError";
		} else if (this.Pass == "") {
			isErr = true;
			messageKey = "message.PasswordIsEmptyError";
		}
		if (isErr) {
			this.router.navigate(
				[
					{
						outlets: {
							notification: "notification/" + messageKey
						}
					}
				],
				{
					replaceUrl: true
				}
			);
			return false;
		}
		return true;
	}

	logout() {
		this.authService.logout();
	}

	bank() {
		return this.templateType.whatBank(this.whatBank);
	}
}
